import { View } from 'tamagui';

export const DividerLine = () => (
  <View height={1} flexShrink={0} alignSelf="stretch" backgroundColor="$white2" />
);
